module.exports = __webpack_public_path__ + "static/media/MentorMareike.34dfe0bc.jpg";